import axios, { type InternalAxiosRequestConfig } from 'axios';
import { getToken } from './auth';

/**
 * Storefront HTTP client.
 *
 * Talks to the SAME backend as the PMS, but ONLY through the public API surface
 * mounted at `/v1/public`. It must never call staff/operator endpoints — those
 * require staff RBAC and expose internal data (folios, payouts, notes).
 *
 * Base URL resolution mirrors the PMS app: when VITE_API_URL is set we call the
 * deployed API directly, otherwise we rely on the Vite dev proxy.
 */
const _apiBase = import.meta.env.VITE_API_URL;
const _baseURL = _apiBase ? `${_apiBase}/v1/public` : '/v1/public';

export const api = axios.create({
  baseURL: _baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 15_000,
});

// Attach the guest bearer token when present. Most public browse/search routes
// are anonymous; auth is only needed for guest account + booking actions.
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = getToken();
    if (token && config.headers) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error: unknown) => Promise.reject(error),
);

export default api;
